var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBreakpointsStudioMobileV = function SvgBreakpointsStudioMobileV(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18h-5A1.502 1.502 0 0 1 8 16.5v-9A1.502 1.502 0 0 1 9.5 6h5A1.502 1.502 0 0 1 16 7.5v9a1.502 1.502 0 0 1-1.5 1.5Zm-5-11a.5.5 0 0 0-.5.5v9a.501.501 0 0 0 .5.5h5a.501.501 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-5Z",
    fill: "#fff"
  })));
};
export default SvgBreakpointsStudioMobileV;